import { ValueProvider } from "@angular/core";
import { FEATURE_FLAGS } from "../constants/feature-flags-token";

export function provideFeatureFlags(featureFlagConfig: Record<string, boolean>): ValueProvider {
  if (!featureFlagConfig || Object.keys(featureFlagConfig).length === 0) {
    return {
      provide: FEATURE_FLAGS,
      useValue: null,
    };
  }
  return {
    provide: FEATURE_FLAGS,
    useValue: featureFlagConfig,
  };
}
